module.exports = __webpack_public_path__ + "static/media/icon-wishlist.627b6b99.svg";